import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'

import { VideoListStyle } from '../styles'
import VideoModal from '../modals/VideoModal'
import ResourceDescription from '../shared/ResourceDescription'
import ResourceList from './ResourceList'
import { openExternal } from '../../utils/safeUrl'

const VideoList = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    const secondary = (
        <>
            <ResourceDescription
                description={props.description}
                containerSx={VideoListStyle.titleContainer}
                typographyProps={{ ...VideoListStyle.description, gutterBottom: true }}
            />
            <Box sx={VideoListStyle.secondary}>
                <Typography {...VideoListStyle.text}>
                    <span style={{"fontWeight":"bold"}}>Channel:</span> {props.authors}
                </Typography>
            </Box>
        </>
    )

    return (
        <ResourceList
            Icon={PlayArrowIcon}
            listStyle={VideoListStyle}
            modal={<VideoModal {...props} />}
            title={props.title}
            date={props.pub_date}
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
            secondaryContent={secondary}
        />
    )
}

export default VideoList
